module.exports = __webpack_public_path__ + "media/landing_page/instacart-microsoft-lockup-4efb8e73.svg";